// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8vOHH","col":"styles_col__16p4E"};